module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-txt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Front cover:")]), _vm._v(" Former GNR(I) U class 4-4-0 No.199, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lough Derg")]), _vm._v(", prepares to depart from Dublin Amiens Street in July 1959. Built by Beyer, Peacock in April 1915, this engine was transferred on 1 October 1958 to CIE (the last letter of which is visible stencilled in white on the bufferbeam) upon the demise of the GNR Board and was withdrawn in November 1962. The locomotive received its name in April 1949. "), _c('span', {
    staticClass: "small"
  }, [_vm._v("(Donald Nevin)")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-txt1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Title page:")]), _vm._v(" UTA W class 2-6-0 No.91, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Bush")]), _vm._v(", simmers at Portadown shed, Co Armagh, in May 1962. The locomotive, which bears the name of a local river, was the second member of the W class (numbered 90-104) and was built at the Derby Works of the LMS, being delivered to the NCC in July 1933. It was scrapped in May 1965. "), _c('span', {
    staticClass: "small1"
  }, [_vm._v("(Jim Oatway)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21daec45","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02a_fm.vue
// module id = 66
// module chunks = 0